import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

// Estilos do PDF Viewer
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

// URL do worker correta para evitar "fake worker"
const pdfWorkerUrl = 'https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js';

const PdfViewer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  // Recupera o parâmetro da URL
  const params = new URLSearchParams(location.search);
  const fileUrl = params.get('file');

  const [ready, setReady] = useState(false);

  useEffect(() => {
    // Atraso mínimo para evitar ResizeObserver warning
    const timer = setTimeout(() => setReady(true), 10);
    return () => clearTimeout(timer);
  }, [fileUrl]);

  return (
    <div style={{ height: '100vh', width: '100vw', display: 'flex', flexDirection: 'column' }}>

      {/* Barra superior com botão de voltar */}
      <div
        style={{
          padding: '10px',
          backgroundColor: '#f0f0f0',
          borderBottom: '1px solid #ccc'
        }}
      >
        <button
          onClick={() => navigate(-1)}
          style={{
            padding: '8px 16px',
            fontSize: '14px',
            cursor: 'pointer',
            borderRadius: '4px',
            border: '1px solid #ccc',
            backgroundColor: '#fff'
          }}
        >
          ← Voltar
        </button>
      </div>

      {/* Área do visualizador */}
      <div style={{ flex: 1, height: '100%', overflow: 'hidden', position: 'relative' }}>
  <Worker workerUrl={pdfWorkerUrl}>
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div id="pdf-viewer-header" style={{ flexShrink: 0, zIndex: 10 }} />
      <div style={{ flex: 1, overflow: 'auto' }}>
        <Viewer
          key={fileUrl}
          fileUrl={fileUrl}
          plugins={[defaultLayoutPluginInstance]}
        />
      </div>
    </div>
  </Worker>
</div>
    </div>
  );
};

export default PdfViewer;
